import { Utility } from "../../util/utility";

const setCSSVariables = () => {
    let currentWidth = window.innerWidth;
    const mv_siwrap = document.querySelector(".mv__siwrap");
    const spacer = [...document.querySelectorAll(".mv__spacer")];

    const getSpacerHeight = () => {
        let height = 0;

        spacer.forEach((el) => {
            height += el.offsetHeight;
        });

        return height;
    };

    const setHeight = () => {
        if (!mv_siwrap) {
            return;
        }
        document.documentElement.style.setProperty("--screenHeight", window.innerHeight + "px");

        const spacerHeight = getSpacerHeight();
        const wrapHeight = mv_siwrap.offsetHeight;
        const safeHeight = window.innerHeight - spacerHeight;

        let scale = 1;

        if (safeHeight < wrapHeight) {
            scale = safeHeight / wrapHeight;
        }

        document.documentElement.style.setProperty("--scaleHeight", scale);
    };

    const onReseize = () => {
        setHeight();
    };

    setHeight();
    window.addEventListener("load", onReseize);

    //IOS対応版
    window.addEventListener("resize", function () {
        if (currentWidth == window.innerWidth && window.innerWidth < 835) {
            return;
        }

        currentWidth = window.innerWidth;
        setHeight();
    });
};

export { setCSSVariables };
